import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import MdMenu from 'react-icons/lib/md/menu';
import MdSearch from 'react-icons/lib/md/search';

import OverviewIcon from '../components/icons/Overview';
import StocksIcon from '../components/icons/Stocks';
import IndicesIcon from '../components/icons/Indices';
import CurrenciesIcon from '../components/icons/Currencies';
import CommoditiesIcon from '../components/icons/Commodities';

import { search } from '../actions/search';
import { toggleMenu } from '../redux/app';

import MenuItem from './MenuItem';
import SearchField from './SearchField';

import css from '../styles/header';

const mapDispatchToProps = {
    toggleMenu,
    search,
};

const mapStateToProps = state => {
    const {
        menuTitle,
        menuOpen,
        focusSearch,
    } = state.app;

    const {
        open,
        query,
        results,
    } = state.search;

    return {
        menuTitle,
        menuOpen,
        focusSearch,
        searchOpen: open,
        searchQuery: query,
        results,
    };
};

class Header extends Component {
    static propTypes = {
        menuTitle: PropTypes.string.isRequired,
        menuOpen: PropTypes.bool.isRequired,
        searchOpen: PropTypes.bool.isRequired,
        searchQuery: PropTypes.string.isRequired,
        focusSearch: PropTypes.bool,
        search: PropTypes.func,
        className: PropTypes.string,
        results: PropTypes.array,
        toggleMenu: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const { t } = props;

        this.menuItems = [
            [t('overview'), '/', <OverviewIcon />, true],
            [t('stocks'), '/aktier', <StocksIcon />, true],
            [t('indices'), '/index', <IndicesIcon />],
            [t('currency'), '/valuta', <CurrenciesIcon />],
            [t('commodities'), '/ravaror', <CommoditiesIcon />],
        ];

        this._toggleMenu = () => {
            window.scrollTo(0, 0);
            this.props.toggleMenu();
        };

        this._openMenuWithSearchFocus = e => {
            e.stopPropagation();
            this.props.toggleMenu(true);
        };
    }

    componentDidUpdate(prevProps) {
        const { menuOpen } = this.props;

        if (prevProps.menuOpen !== menuOpen) {
            if (menuOpen) {
                document.body.classList.add('menuOpen');
            } else {
                document.body.classList.remove('menuOpen');
            }
        }
    }

    renderBackdrop() {
        if (!this.props.menuOpen) return null;

        return <div className={css.backdrop} onClick={this._toggleMenu} />;
    }

    renderMenuButton() {
        if (this.props.menuOpen) {
            return (
                <SearchField
                    toggleMenu={this._toggleMenu}
                    isOpen={this.props.searchOpen}
                    query={this.props.searchQuery}
                    results={this.props.results}
                    search={this.props.search}
                    focusSearch={this.props.focusSearch}
                />
            );
        }

        return (
            <div className={css.menu}>
                <div className={css.menuInner} onClick={this._toggleMenu}>
                    <div className={css.menuButton}>
                        <MdMenu size="24" />
                    </div>
                    <div className={css.searchButton} onClick={this._openMenuWithSearchFocus}>
                        <MdSearch size="24" />
                    </div>
                    <span>{this.props.menuTitle}</span>
                </div>
            </div>
        );
    }

    renderMenuItems() {
        const { menuTitle, menuOpen, searchOpen } = this.props;

        if (!menuOpen || searchOpen) return null;

        const items = [];

        for (const [label, link, icon, wide] of this.menuItems) {
            items.push(<MenuItem
                key={label} label={label} link={link} icon={icon} wide={wide}
                onClick={this._toggleMenu} active={label === menuTitle}
            />);
        }

        return (
            <div className={css.menuItems}>
                <div className={css.menuScrollWrapper}>{items}</div>
            </div>
        );
    }

    render() {
        return (
            <div className={css.container}>
                {this.renderBackdrop()}
                {this.renderMenuButton()}
                {this.renderMenuItems()}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('menu')(Header));



/** WEBPACK FOOTER **
 ** /src/shared/parts/Header.js
 **/